import {
  useSurveyStore,
  selectActiveQuestion
} from "views/landlord-surveys-id/store";
import { SidebarQuestions } from "../sidebar-questions";
import { Card } from "shared/components/Card";
import { IconButton, IconButtonSize } from "shared/components";
import { Copy01Icon, Delete01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Widget } from "./widgets";
import { WidgetConfiguration } from "./widget-configuration";
import { StartSurveySlice } from "views/land-x-token/slices/StartSurvey";
import { EndSurveySlice } from "views/land-x-token/slices/EndSurvey";

const QuestionEditor = () => {
  const activeQuestion = useSurveyStore(selectActiveQuestion);
  const deleteQuestion = useSurveyStore((state) => state.deleteQuestion);
  const duplicateQuestion = useSurveyStore((state) => state.duplicateQuestion);

  return (
    <main className="bg-background-900 py-12 px-4 w-full">
      <div
        className="mx-auto flex flex-wrap lg:flex-nowrap gap-4 animate-appear max-w-[1000px] w-full"
        key={activeQuestion?.internal_id}
      >
        <Card className="min-w-[300px] max-w-[640px] flex flex-col min-h-[320px] p-6">
          <div className="flex-grow w-full">
            <Widget />
          </div>
          <footer className="mt-6 pt-6 border-t border-alpha-40 flex gap-2 justify-end">
            <IconButton
              size={IconButtonSize.SM}
              HugeIcon={Delete01Icon}
              onClick={deleteQuestion}
            />
            <IconButton
              size={IconButtonSize.SM}
              HugeIcon={Copy01Icon}
              onClick={duplicateQuestion}
            />
          </footer>
        </Card>
        <WidgetConfiguration />
      </div>
    </main>
  );
};

const PagePreview = ({ children }: { children: React.ReactNode }) => (
  <main className="bg-background-900 flex-grow flex items-center justify-center p-4">
    <div className="max-w-[992px] w-full h-[calc(100vh-72px-48px)] rounded-2xl border border-alpha-100 shadow-lg bg-white overflow-hidden animate-appear">
      {children}
    </div>
  </main>
);

export const QuestionsSlice = () => {
  const activePage = useSurveyStore((state) => state.activePage);

  return (
    <div className="flex animate-appear">
      <SidebarQuestions />

      {activePage === "start" && (
        <PagePreview>
          <StartSurveySlice />
        </PagePreview>
      )}

      {activePage === "end" && (
        <PagePreview>
          <EndSurveySlice />
        </PagePreview>
      )}

      {activePage === "question" && <QuestionEditor />}
    </div>
  );
};
